module.exports = __webpack_public_path__ + "static/media/ZT1.c9107c59.jpg";